import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class VacanciesApi extends Api {
  constructor() {
    super('cv/vacancies/');
  }

  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/approve`,
    );
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/vacancies.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  getPDF(id) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/vacancies/${id}/file`,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default VacanciesApi;
